var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_427",
    "data-name": "Group 427",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.327 18.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #070606;\n      }\n\n      .cls-2 {\n        fill: #d10000;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    transform: "translate(16.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-1",
    d: "M65.031,3.461,62.746,5.644A7.016,7.016,0,0,0,57.5,3.192a5.625,5.625,0,0,0-4.133,1.68,5.7,5.7,0,0,0-1.68,4.166,6.148,6.148,0,0,0,.739,3.057,5.484,5.484,0,0,0,2.117,2.083,6.132,6.132,0,0,0,3.024.773,5.947,5.947,0,0,0,2.587-.538,9.793,9.793,0,0,0,2.587-1.949l2.217,2.318a12.534,12.534,0,0,1-3.595,2.587,10.026,10.026,0,0,1-3.864.706,8.861,8.861,0,0,1-6.552-2.553A8.732,8.732,0,0,1,48.4,9a8.981,8.981,0,0,1,1.176-4.569A8.539,8.539,0,0,1,52.9,1.21,9.273,9.273,0,0,1,57.539,0a9.958,9.958,0,0,1,7.492,3.461Z",
    transform: "translate(-48.4)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(35.916 0.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "cls-1",
    d: "M106.9,1.3h3.461a11.682,11.682,0,0,1,4.065.5,4.275,4.275,0,0,1,1.949,1.68,5.011,5.011,0,0,1,.739,2.789,4.677,4.677,0,0,1-.806,2.822,4.645,4.645,0,0,1-2.453,1.713l4.065,7.66h-3.595l-3.864-7.291h-.3v7.291H106.9Zm3.259,6.72h1.008a4.092,4.092,0,0,0,2.15-.4,1.5,1.5,0,0,0,.571-1.344,1.6,1.6,0,0,0-.3-.974,1.942,1.942,0,0,0-.773-.6,5.547,5.547,0,0,0-1.781-.168h-.907V8.02Z",
    transform: "translate(-106.9 -1.3)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(49.59 0.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "cls-1",
    d: "M147.6,1.3h9.374V4.492h-6.115V7.616h6.115v3.158h-6.115V15.31h6.115v3.225H147.6Z",
    transform: "translate(-147.6 -1.3)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(62.021 0.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "cls-1",
    d: "M184.634,1.3H188.5a12.635,12.635,0,0,1,5.577.941,7.019,7.019,0,0,1,2.99,3.024,9.955,9.955,0,0,1,1.176,4.872,10,10,0,0,1-.672,3.662,7.581,7.581,0,0,1-1.814,2.755,6.175,6.175,0,0,1-2.52,1.512,18.236,18.236,0,0,1-4.7.437H184.6V1.3Zm3.225,3.158V15.31h1.512a7.824,7.824,0,0,0,3.259-.5,3.8,3.8,0,0,0,1.646-1.747,6.248,6.248,0,0,0,.638-2.99,5.608,5.608,0,0,0-1.545-4.233c-.907-.907-2.385-1.344-4.435-1.344h-1.075Z",
    transform: "translate(-184.6 -1.3)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339",
    transform: "translate(78.686 0.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "cls-2",
    d: "M234.2,1.3h1.713V18.5H234.2Z",
    transform: "translate(-234.2 -1.3)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340",
    transform: "translate(82.919 0.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "cls-2",
    d: "M246.8,2.98V1.3h9.407V2.98h-3.83V18.5H250.63V2.98Z",
    transform: "translate(-246.8 -1.3)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341",
    transform: "translate(0 3.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-2",
    d: "M8.5,17.952l1.042.538A5.563,5.563,0,0,1,8.366,20.1a4.41,4.41,0,0,1-1.512.941,5.517,5.517,0,0,1-1.881.336A4.537,4.537,0,0,1,1.31,19.834,5.113,5.113,0,0,1,0,16.373a5.239,5.239,0,0,1,1.109-3.259,4.575,4.575,0,0,1,3.8-1.814,4.7,4.7,0,0,1,3.9,1.848,4.989,4.989,0,0,1,1.042,3.259H1.277a3.833,3.833,0,0,0,1.075,2.721A3.424,3.424,0,0,0,4.905,20.2a4.047,4.047,0,0,0,1.411-.269,3.989,3.989,0,0,0,1.176-.672A4.186,4.186,0,0,0,8.5,17.952Zm0-2.553a4.306,4.306,0,0,0-.706-1.579,3.215,3.215,0,0,0-1.243-.941,3.781,3.781,0,0,0-1.613-.37,3.491,3.491,0,0,0-2.419.907A3.9,3.9,0,0,0,1.411,15.4H8.5Z",
    transform: "translate(0 -11.3)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342",
    transform: "translate(10.785 6.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-2",
    d: "M33.948,20.4a1.775,1.775,0,0,1,1.31.538,1.7,1.7,0,0,1,.538,1.277,1.775,1.775,0,0,1-.538,1.31,1.724,1.724,0,0,1-1.31.538A1.835,1.835,0,0,1,32.1,22.214a1.652,1.652,0,0,1,.538-1.277A1.775,1.775,0,0,1,33.948,20.4Z",
    transform: "translate(-32.1 -20.4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fcb2f897227a2ff4ea9bd268611e4228.svg";
export { ForwardRef as ReactComponent };